// extracted by mini-css-extract-plugin
export default {"cart_form":"CartForm_cart_form__NXXio","paymentSegment":"CartForm_paymentSegment__TYkg1","shake":"CartForm_shake__xJZoJ"};